<template>
  <div class="base-loading-overlay">
    <base-spinner />
  </div>
</template>

<script>
export default {
  name: "BaseLoadingOverlay",
};
</script>

<style lang="scss" scoped>
@import "./base-loading-overlay.scss";
</style>
